import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.EmailConfirmation', {
    linkSent: 'A verification link has been sent to',
    clickToVerify: 'Click it to verify your email address',
    changeEmail: 'Change email',
    openGmail: 'Open Gmail',
    openYahoo: 'Open Yahoo',
    openOutlook: 'Open Outlook',
    findEmail: "Can't find the email?",
    checkEmailAndSpam: 'Check your email address, spam folder or hit "Resend"',
    resend: 'Resend',
    resendIn: 'Resend in {time}',
});
